import useFlags from "hooks/useFlags";
import styled, { css } from "styled-components";

export const Container = styled.section`
  ${({ theme }) => {
    const { isCommunitySectionEnabled } = useFlags()

    const headerHeight = theme.old.sizes.header;
    const { isMobile } = theme.old.breakpoints;

    if (isCommunitySectionEnabled) {
      return css`
        ${isMobile} {
          height: 100%;
          margin-top: 140px;
          min-height: calc(100vh - 200px);
        }
      `
    }

    return css`
      height: 100%;
      padding-top: ${headerHeight};
      min-height: ${`calc(100vh - ${headerHeight})`};
    `
  }}
`